import React from "react";

const Loading = () => {
  return (
    <div>
      <img
        className="items-center flex mx-auto justify-center "
        src="https://i.ibb.co/4tPL22s/loading-waiting.gif"
        alt=""
      />
    </div>
  );
};

export default Loading;
